export default "__VITE_ASSET___XYErwi___"